import { render, staticRenderFns } from "./IntegralExchange.vue?vue&type=template&id=933610a2&"
import script from "./IntegralExchange.vue?vue&type=script&lang=js&"
export * from "./IntegralExchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports